import { Component, inject, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { TokenRefreshService } from "./core/auth/services";
import { ThemeService } from "./core/services/theme.service";
import { KeycloakService } from "keycloak-angular";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: true,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  private _keycloakService = inject(KeycloakService);
  private _tokenRefreshService = inject(TokenRefreshService);
  // Se inyecta acá para que el tema del tenant se aplique al arrancar, y no
  // recién cuando se crea el layout (que además no existe en layout "empty").
  private _themeSVC = inject(ThemeService);

  ngOnInit(): void {
    // El APP_INITIALIZER ya resolvió si hay sesión (tokens guardados, o
    // check-sso si no había) antes de que se evalúe cualquier guard, así que
    // acá solo decidimos si arrancar el refresh en segundo plano.
    if (this._keycloakService.isLoggedIn()) {
      this._tokenRefreshService.start();
    }
  }
}
